/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useNavigationDrawerStyles = makeStyles<Theme, { drawerWidth: number }>({
  drawer: {
    display: 'flex',
    flexShrink: 0,
    width: ({ drawerWidth = 0 }) => drawerWidth,
  },
  drawerPaper: {
    width: ({ drawerWidth = 0 }) => drawerWidth,
    borderRight: '1px solid #EEEEEE',
  },
});
